<template>
  <div>
    <h4 class="mb-1">
      <v-icon right>mdi-file-document-edit-outline</v-icon> Registrar Pagos
    </h4>
    <v-row>
      <v-col md="6" sm="12" class="text-center text-h6">
        <v-autocomplete
          label="Metodo de Pago"
          v-model="form.metodo_pago"
          :items="metodo_pago"
          item-text="tipo"
          item-value="id"
          return-object
          dense
          placeholder="Seleccione el Metodo de pago"
          class="mt-4"
          @change="updateShowInput()"
        >
        </v-autocomplete>
      </v-col>
      <v-col md="6" sm="12">
        <v-autocomplete
          label="Tipo de Pago"
          v-model="form.tps_modalidad_pago"
          :items="modalidadPagos"
          item-text="nombre"
          item-value="id"
          return-object
          dense
          placeholder="Seleccione el Tipo de pago"
          class="mt-4"
        >
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="6" sm="12">
        <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="form.fecha_pago"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.fecha_pago"
                        prepend-icon="mdi-calendar-month"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                        placeholder="Fecha de pago"
                        dense
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.fecha_pago"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(form.fecha_pago)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
      </v-col>
      <v-col md="6" sm="12" v-if="showInput">
        <v-autocomplete
          id="i_pago_dialog_banco"
          v-model="form.dts_cuentas"
          :items="cuentasBancarias"
          item-text="descripcion"
          item-value="id"
          return-object
          dense
          placeholder="Seleccione la Cuenta Bancaria"
        >
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="12" sm="12">
        <v-text-field
          id="i_pago_dialog_codigo"
          label="Código de Pago"
          v-model="form.codigo"
          maxlength="14"
          @keypress="allowNumericInput"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="12" sm="12">
        <v-text-field
          id="i_pago_dialog_monto"
          label="Monto a Pagar"
           v-model="form.monto"
          suffix="Bs"
          class="mr-2"
          @keypress="allowNumericInput"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="12" sm="12" class="text-center">
        <v-btn
            type="button"
            color="green darken-1 white--text"
            @click="addPago()"
          >
            <v-icon small>mdi-plus</v-icon>
            <v-divider class="mx-4" inset vertical></v-divider>
            Agregar Pago
          </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex"
import messageMixin from "@/mixins/common"

export default {
  name: "agregar-pagos-pedidos",
  mixins: [messageMixin],
  data() {
    return {
      showInput: false,
      form: {
        fecha_pago: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substr(0, 10),
        metodo_pago: null,
        tps_modalidad_pago: null,
        dts_cuentas: null,
        codigo: null,
        monto: null
      },

      metodo_pago: [
        {
          id: 1,
          tipo: "Deposito",
        },
        {
          id: 2,
          tipo: "Transferencia",
        },
        {
          id: 3,
          tipo: "Efectivo",
        },
        {
          id: 4,
          tipo: "Punto de Venta",
        },
        {
          id: 5,
          tipo: "Criptomoneda",
        },
      ],
       rules: {
        required: (value) => !!value || "Requerido.",
       }
    }
  },

  computed: {
    ...mapGetters("Pagos", ["modalidadPagos"]),
    ...mapState("Cuentas", {getCuentas: "entrys"}),
    cuentasBancarias() {
      return this.getCuentas.map((item) => {
        let account = {}
        account.id = item.id
        account.descripcion = `${item.dts_banco.nombre}`

        return account
      })
    },
  },

  methods: {
    ...mapActions("Cuentas", { loadCuentas: "getEntry" }),
    ...mapActions("Pagos", ["getModalidadPagos"]),

    updateShowInput() {
      console.log(this.form.metodo_pago)
      if( this.form.metodo_pago.id >= 3 ) {
        this.showInput = false
        return false;
      }

      this.showInput = true
    },

    addPago() {
      this.$emit('addNewPago', this.form);
      this.resetForm()
    },

    resetForm() {
        this.form.metodo_pago = null;
        this.form.tps_modalidad_pago = null;
        this.form.dts_cuentas = null;
        this.form.codigo = null;
        this.form.monto = null;

    }
  },
  mounted() {
    this.getModalidadPagos()
    this.loadCuentas()
  },
}
</script>
